import { render, staticRenderFns } from "./hammer.vue?vue&type=template&id=5b8d849c"
import script from "./hammer.vue?vue&type=script&lang=js"
export * from "./hammer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports